import type { Template } from "@/types";

export const PO_06_H6_V0: Template[] = [
    {
        id: "po-06-h6v0-01",
        name: "PO 01 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 50, y: 134, width: 502, height: 378, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 50, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 305, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 663, y: 177, width: 458, height: 326, rotation: 0, imageRotation: 0 },
            { id: "5", x: 663, y: 511, width: 225, height: 162, rotation: 0, imageRotation: 0 },
            { id: "6", x: 896, y: 511, width: 225, height: 162, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-02",
        name: "PO 02 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 50, y: 134, width: 502, height: 378, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 305, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 134, width: 502, height: 378, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-03",
        name: "PO 03 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 50, y: 134, width: 502, height: 378, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 305, y: 520, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 338, width: 502, height: 378, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 135, width: 247, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 135, width: 247, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-04",
        name: "PO 04 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 138, y: 81, width: 318, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 138, y: 313, width: 318, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 138, y: 545, width: 318, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 733, y: 81, width: 318, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 733, y: 313, width: 318, height: 224, rotation: 0, imageRotation: 0 },
            { id: "6", x: 733, y: 545, width: 318, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-05",
        name: "PO 05 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 246, y: 81, width: 345, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 246, y: 313, width: 345, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 246, y: 545, width: 345, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 81, width: 345, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 599, y: 313, width: 345, height: 224, rotation: 0, imageRotation: 0 },
            { id: "6", x: 599, y: 545, width: 345, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-06",
        name: "PO 06 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 106, y: 0, width: 384, height: 278, rotation: 0, imageRotation: 0 },
            { id: "2", x: 106, y: 286, width: 384, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 106, y: 572, width: 384, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 701, y: 0, width: 384, height: 278, rotation: 0, imageRotation: 0 },
            { id: "5", x: 701, y: 286, width: 384, height: 278, rotation: 0, imageRotation: 0 },
            { id: "6", x: 701, y: 572, width: 384, height: 278, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-07",
        name: "PO 07 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_07.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 57, y: 207, width: 283, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 429, width: 283, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 347, y: 207, width: 590, height: 436, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 207, width: 188, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 945, y: 355, width: 188, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 945, y: 503, width: 188, height: 140, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-08",
        name: "PO 08 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 56, y: 161, width: 355, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 430, width: 355, height: 260, rotation: 0, imageRotation: 0 },
            { id: "3", x: 419, y: 161, width: 354, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 419, y: 430, width: 354, height: 260, rotation: 0, imageRotation: 0 },
            { id: "5", x: 781, y: 161, width: 354, height: 261, rotation: 0, imageRotation: 0 },
            { id: "6", x: 781, y: 430, width: 354, height: 260, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-09",
        name: "PO 09 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 177, width: 591, height: 497, rotation: 0, imageRotation: 0 },
            { id: "2", x: 599, y: 177, width: 248, height: 161, rotation: 0, imageRotation: 0 },
            { id: "3", x: 599, y: 346, width: 248, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 514, width: 248, height: 160, rotation: 0, imageRotation: 0 },
            { id: "5", x: 855, y: 177, width: 335, height: 245, rotation: 0, imageRotation: 0 },
            { id: "6", x: 855, y: 430, width: 335, height: 244, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-10",
        name: "PO 10 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 273, width: 392, height: 303, rotation: 0, imageRotation: 0 },
            { id: "2", x: 799, y: 273, width: 391, height: 303, rotation: 0, imageRotation: 0 },
            { id: "3", x: 400, y: 273, width: 192, height: 148, rotation: 0, imageRotation: 0 },
            { id: "4", x: 400, y: 429, width: 192, height: 148, rotation: 0, imageRotation: 0 },
            { id: "5", x: 600, y: 273, width: 191, height: 148, rotation: 0, imageRotation: 0 },
            { id: "6", x: 600, y: 429, width: 191, height: 148, rotation: 0, imageRotation: 0 }
        ],
    }
];